import React from "react";
import styles from "./PillLabel.module.css";

export type PillLabelProps = {
  /** Text to show; leading/trailing space is trimmed. Empty string renders nothing. */
  label: string;
  /** Apply uppercase styling (default true). */
  uppercase?: boolean;
  className?: string;
  /** Optional id for aria-labelledby wiring */
  id?: string;
};

/**
 * Reusable small pill for category / area / context labels above headings.
 */
const PillLabel: React.FC<PillLabelProps> = ({
  label,
  uppercase = true,
  className,
  id,
}) => {
  const trimmed = label.trim();
  if (!trimmed) return null;

  return (
    <span
      id={id}
      className={[styles.root, uppercase ? styles.uppercase : "", className].filter(Boolean).join(" ")}
    >
      {trimmed}
    </span>
  );
};

export default PillLabel;
